import { render, staticRenderFns } from "./AttachDocFile.vue?vue&type=template&id=01055360&scoped=true"
import script from "./AttachDocFile.vue?vue&type=script&lang=js"
export * from "./AttachDocFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01055360",
  null
  
)

export default component.exports